import { User } from 'lucide-react'

import { getFullName } from 'components/reusable/form/StateDropdown'
import { cn } from 'utils'

import { type Allowance } from './FlatAllowanceExplorer'

type Props = {
  allowance: Allowance
}

function AllowanceClassHeader ({ allowance }: Props) {
  return (
    <div className='flex flex-col gap-1'>
      <div
        className={cn('text-sm text-gray-800 font-semibold', {
          'text-gray-500': !allowance.class?.location_id,
        })}
        data-testid='state-name'
      >
        {getFullName(allowance.class?.location_id || '') || 'Select a state'}
      </div>
      <div className='flex items-center gap-1'>
        <User className='w-3 h-3 text-gray-500' />
        <span className='text-xs text-gray-500'>
          {[
            `$${allowance.flat_config?.employee_amount || 0} per employee`,
            `$${allowance.flat_config?.spouse_amount || 0} for first dependent`,
            `$${allowance.flat_config?.dependent_amount || 0} for additional dependents`,
          ].join(' • ')}
        </span>
      </div>
    </div>
  )
}

export default AllowanceClassHeader
